export default "__VITE_ASSET__BNWKnOgu__"